module.exports = __webpack_public_path__ + "static/media/website-08.b6b46428.mp4";